<template>
  <div>
    <div class="breadcrumb">
      <h1 class="breadcrumb-title">Gifts Reports</h1>
    </div>

    <!-- Breadcrumbs -->
    <div class="breadcrumbs">
      <router-link to="/dashboard">Dashboard</router-link> /
      <b>Marketing</b> /
      <router-link :to="{ name: 'gift-report-page' }">Gift Reports</router-link> /
      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <div id="active">
              <h4 class="card-title mb-3"><b>{{ gift_name }}</b></h4>
              <div class="d-flex flex-row justify-content-between mb-3">
                <form @submit.prevent="handleFilter" class="d-flex w-50">
                  <div class="w-25">
                    <input type="number" class="form-control" v-model="yearSearch" placeholder="Year" />
                  </div>
                  <div class="ml-4">
                    <button type="submit" class="btn btn-primary rounded-3">Filter</button>
                  </div>
                </form>

                <form @submit.prevent="handleSearch" class="d-flex">
                  <input type="text" class="form-control" v-model="searchInput" placeholder="Search" />
                  <button type="submit" class="btn btn-primary ml-1 mr-1">
                    <i class="fas fa-search"></i>
                  </button>
                  <button type="button" class="btn btn-primary" @click="resetFilter">Reset Filter/Search</button>
                </form>
              </div>

              <div class="table-responsive">
                <table id="tbl_gifts" class="table table-striped table-bordered text-center" style="width: 100%;">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Takaful ID</th>
                      <th>Selected at</th>
                      <th>Redeemed at</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="redeems.length === 0">
                      <td colspan="4">No Data Found.</td>
                    </tr>
                    <tr v-else v-for="(redeem, index) in redeems" :key="index">
                      <td>{{ getRunningNumber(index) }}</td>
                      <td>{{ redeem.user.takaful_id }}</td>
                      <td>{{ redeem.selected_at }}</td>
                      <td>{{ redeem.redeemed_at }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="d-flex flex-row">
                  <div class="mr-2">
                    <pagination
                      aria-disabled="true"
                      v-model="pageInfo.current_page"
                      :per-page="pageInfo.per_page"
                      :records="pageInfo.total"
                      @paginate="handlePageChange"
                    />
                  </div>
                  
                  <div v-if="pageInfo.total > 10" class="d-flex flex-row flex-shrink">
                    <input type="number" class="form-control mr-2" v-model="page_number" />
                    <button class="align-self-start btn btn-primary" type="button" @click="jumpTo">Jump to page</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSelectedGift } from '../../../../services/GiftServices';
import Pagination from 'vue-pagination-2';

export default {
  components: { Pagination },

  data() {
    return {
      pageInfo: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0
      },
      redeems: [],
      yearSearch: '',
      searchInput: '',
      gift_name: '',
      extraRequest: null,
      page_number: 1,
    };
  },

  methods: {
    async fetchData(extraRequest = null) {
      try {
        const { data } = await getSelectedGift(this.$route.params.id, extraRequest);
        this.redeems = data.data.selected_gifts;
        this.pageInfo = data.data.pagination;
      } catch (e) {
        console.error(e);
      }
    },

    buildExtraRequest() {
      const filters = [];
      if (this.yearSearch) filters.push(`year=${this.yearSearch}`);
      if (this.searchInput) filters.push(`search=${this.searchInput}`);
      return filters.length ? `?${filters.join('&')}` : null;
    },

    async handleFilter() {
      this.extraRequest = this.buildExtraRequest();
      await this.fetchData(this.extraRequest);
    },

    async handleSearch() {
      this.extraRequest = this.buildExtraRequest();
      await this.fetchData(this.extraRequest);
    },

    async resetFilter() {
      this.yearSearch = '';
      this.searchInput = '';
      this.extraRequest = null;
      await this.fetchData();
    },

    async handlePageChange(page) {
      const extraRequest = this.extraRequest ? `${this.extraRequest}&page=${page}` : `?page=${page}`;
      await this.fetchData(extraRequest);
    },

    async jumpTo() {
      if(!this.checkPageEligibility()) {
        return swal({
          text: 'Page number does not exist.',
          icon: "warning"
        })
      }

      await this.handlePageChange(this.page_number)
      this.pageInfo.current_page = this.page_number;
    },

    checkPageEligibility() {
      if(this.page_number > this.pageInfo.last_page) {
        return false;
      }

      if(this.page_number <= 0) {
        return false;
      }

      return true;
    },

    getName() {
      this.gift_name = sessionStorage.getItem('gifts_name');
    },

    getRunningNumber(index) {
      return index + 1 + (this.pageInfo.current_page - 1) * this.pageInfo.per_page;
    },
  },

  async mounted() {
    await this.fetchData();
    this.getName();
  },
};
</script>

<style scoped>
.breadcrumb-title {
  color: #AC8400;
}
.breadcrumbs {
  padding: 10px;
  background-color: #F2F2F2;
}
</style>
